// @ts-strict-ignore
import React from 'react';
import { MultiSelect } from '@usealloy/component-library';
import type { MultiSelectProps, SelectedOption } from '@usealloy/component-library';
import { getSelectedOption } from '../NodeEditorDrawer/ThresholdsTab/RuleBuilderContainer/Rule/Threshold/helpers';
import { StyledAggregationSelectWrapper } from './styles';

/** Option shape for aggregation dropdowns (label + value). */
export type AggregationOption = { label: string; value: string };

type AggregationSelectProps<T extends AggregationOption> =
  Omit<MultiSelectProps, 'onChange' | 'options' | 'selectedOptions' | 'isMulti'> & {
    multiSelectProps: Partial<MultiSelectProps>;
    options: T[];
    value: string;
    onChange: (option: T) => void;
  };

/** Dropdown for aggregation criteria. Single-select only; value is form field value. */
function AggregationSelect<T extends AggregationOption>({
  multiSelectProps,
  options,
  value,
  onChange,
  ...props
}: AggregationSelectProps<T>) {
  const fallbackOption: AggregationOption = { value, label: value };
  const selectedOption: AggregationOption = options.length > 0
    ? (getSelectedOption({ incomingValue: value, options }) ?? fallbackOption)
    : fallbackOption;
  return (
    <StyledAggregationSelectWrapper>
      <MultiSelect
        {...multiSelectProps}
        {...props}
        options={options}
        selectedOptions={selectedOption}
        onChange={(raw: SelectedOption) => {
          const single = Array.isArray(raw) ? raw[0] : raw;
          if (single) onChange(single as T);
        }}
        isNaked
        isDisabled={false}
        isMulti={false}
      />
    </StyledAggregationSelectWrapper>
  );
}

export default AggregationSelect;
